<template>
  <DModal :show-close="false" :isBgOverlay="true" :placeInTop="true" @close="$emit('close')">
    <div class="d-modal" id="d-create-task-for-user" slot="insertComponent">
      <div class="d-modal__header">
        <h2>Opret person på {{ calendar.name }}</h2>
        <div class="icon__bg-circle" @click="$emit('close')"><span class="icon-cross2"></span></div>
      </div>
      <div class="d-modal__content">
        <div class="input-group">
          <label><span class="icon-user"></span> Vælg personale </label>
          <DSelectCalendarIds itemType="user"
                              :calendarIdsToHide="calendarIdsToHide"
                              :showTags="false"
                              :preSelectedItems="userCalendarIds"
                              :showCreateButton="false"
                              @update="setSelectedUsers">
          </DSelectCalendarIds>
        </div>
      </div>
      <div class="do-modal__footer">
        <button class="do-bttn do-bttn--submit do-bttn--submit--disabled" v-if="!isValidated">{{
            $t('vue2.common.save')
          }}
        </button>
        <button class="do-bttn do-bttn--submit" v-else
                :class="{'do-bttn--submit--loading': isSubmitting}"
                @click="submit">{{ $t('vue2.common.save') }}
        </button>
      </div>
    </div>
  </DModal>
</template>

<script>
import docendo from '../../../docendo'
import DModal from '../../common/DModal'
import dSelect from '../../DSelect/DSelect.vue'
import DSelectCalendarIds from '../../DSelect/DSelectCalsIds.vue'
// import eventbus from '../../../eventbus'

export default {
  components: {DSelectCalendarIds, dSelect, DModal},
  props: {
    calendarAndUsers: {
      type: Object,
      default: null
    },
    schoolId: {
      default: null
    },
    schoolYearId: {
      default: null
    }
  },
  data () {
    return {
      isSubmitting: false,
      userCalendarIds: []
    }
  },
  computed: {
    calendar () {
      return this.calendarAndUsers['calendar']
    },
    activeUsers () {
      return this.calendarAndUsers['users']
    },
    calendarIdsToHide () {
      return this.activeUsers.map(user => user.user_calendar_id)
    },
    isValidated () {
      return this.userCalendarIds.length === 1
    },
    userCalendars () {
      return this.$store.getters.userCalendars
    }
  },
  methods: {
    setSelectedUsers (users) {
      this.userCalendarIds = users.map(user => user.id)
    },
    submit () {
      this.isSubmitting = true
      const calendarId = this.calendar.id
      const subjectName = 'Vagt'
      const color = '#A0A5EF'
      const defaultDuration = 420
      const preparation = null
      const hours = 0
      const subjectType = 'with_kids'
      const subjectCode = null
      docendo.createSubject(subjectName, color, calendarId, defaultDuration, preparation, hours, subjectType, this.schoolId, this.schoolYearId, this.userCalendarIds, subjectCode, false, null, null, null, success => {
        console.log('oprette!', success)
        this.$emit('created', success)
      }, failure => {
        console.log('failure!')
      })
    }
  },
  mounted () {
    this.$nextTick(_ => {
      const el = document.querySelector('.d-select__input-look')
      if (el) {
        el.click()
      }
    })
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  width: 550px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.d-modal__close {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 16px !important;
}

.d-modal__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.d-modal__content {
  padding: 2rem 3rem;
}

.d-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// CreateSubject.vue?30fea04f